import { repositoryConstants } from '../constants'

const initialState = {
  loading: false,
  init: false,
  error: null,
  list: null
}

export default function repository(state = initialState, action: any) {
  switch (action.type) {
    case repositoryConstants.REPOSITORY_LOAD:
      return {
        ...state,
        loading: true,
        init: true
      }
    case repositoryConstants.REPOSITORY_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list
      }
    case repositoryConstants.REPOSITORY_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case repositoryConstants.REPOSITORY_RESET:
      return {
        ...initialState
      }
    default:
      return state
  }
}
